import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(id, data) {
    let params = "";
    if (data) {
      Object.keys(data).forEach(key => {
        params += `${key}=${data[key]}&`;
      });
    }
    return api.get(`/api/v1/stock-movement?stock_id=${id}&${params}`);
  },
  getById(id) {
    return api.get(`/api/v1/stock-movement/${id}`);
  },
  create(data) {
    return api.post(`/api/v1/stock-movement`, data);
  },
  delete(id) {
    return api.delete(`/api/v1/stock-movement/${id}`);
  },
}